import React from 'react';
import PropTypes from 'prop-types';
import { toCamelCase } from 'utilities/stringHelper';
import { FormattedText } from 'core/i18n';

const OtpTransferStepsTitle = ({ name }) => {
    return (
        <div className="otp-name-title-container">
            <div className="otp-name-title">
                <FormattedText value="otpCode-transferOTPCodePersonalText" injectedStrings={[toCamelCase(name)]} />
            </div>
            <span className="dash"></span>
        </div>
    );
};

OtpTransferStepsTitle.propTypes = {
    name: PropTypes.string.isRequired,
};

OtpTransferStepsTitle.defaultProps = {
    name: '',
};

export default OtpTransferStepsTitle;
